import FilterWrapper from "components/filter/wrapper";
import React from "react";
import TagsDrawer from "./tags-drawer";

// Drawer-based tag picker (TagsCombobox stays the classic combobox). Same props and value contract as TagsCombobox (multi: ids array via onValuesChange/onChange,
// single: one id via onChange); only the UI is a drawer now.
export default function TagsFilterCombobox({
  for: forValue,
  module,
  filter,
  hideLabel,
  className,
  isMulti = false,
  values,
  onValuesChange,
  value,
  onChange,
  placeholder,
}) {
  const targetFor = forValue || module;
  const tagsFilter = {
    ...(targetFor ? { for: { _eq: targetFor } } : {}),
    ...filter,
  };

  const content = isMulti ? (
    <TagsDrawer
      isMulti
      filter={tagsFilter}
      values={values || value || []}
      onValuesChange={onValuesChange || onChange}
      placeholder={placeholder || "Select Tags"}
    />
  ) : (
    <TagsDrawer
      filter={tagsFilter}
      values={value ? [value] : []}
      onValuesChange={onChange}
      placeholder={placeholder || "Select Tag"}
    />
  );

  if (hideLabel) return <div className={className}>{content}</div>;
  return (
    <FilterWrapper label="Tags" className={className}>
      {content}
    </FilterWrapper>
  );
}
